var map = {
	"./anthempress.js": 61415,
	"./api.js": 68931,
	"./config.js": 66957,
	"./content-novareader-test.js": 68427,
	"./content-novareader.js": 49526,
	"./ijohs.js": 40522,
	"./koganpage.js": 34061,
	"./lpp.js": 30051,
	"./mybareacts.js": 82906,
	"./new/Login.js": 20275,
	"./new/Register.js": 32277,
	"./researchpad.js": 67254,
	"./vijaynicole.js": 12931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14576;